"use client";
import * as React from "react";

interface FormInputProps {
  label: string;
  className?: string;
  variant?: "light" | "dark";
  value?: string;
  // eslint-disable-next-line no-unused-vars
  onFocus?: (_e: React.ChangeEvent<HTMLInputElement>) => void;
  // eslint-disable-next-line no-unused-vars
  onChange?: (_e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const FormInput: React.FC<FormInputProps> = ({
  label,
  className = "",
  variant = "light",
  value = "",
  onChange,
}) => {
  const [isFocused, setIsFocused] = React.useState(false);

  return (
    <div
      className={`flex-1 basis-[100%] 2xl:basis-0 w-full 2xl:w-[auto] ${className}`}
    >
      <label
        className={`relative block text-base ${
          variant === "dark" ? "text-white" : "text-zinc-600"
        }`}
      >
        <input
          type="text"
          value={value}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          onChange={onChange}
          className={`
            w-full
            py-5
            border-b
            border-solid
            ${
              variant === "dark"
                ? "border-white/20 text-white placeholder-white/70"
                : "border-b-[color:var(--Stroke-2,#E3E3E3)]"
            }
            bg-transparent
            outline-none
            transition-all
            ${isFocused || value ? "pt-6 pb-4" : "py-5"}
          `}
          aria-label={label}
        />
        <span
          className={`
            absolute
            left-0
            transition-all
            pointer-events-none
            ${isFocused || value ? "text-sm top-1" : "top-4"}
          `}
        >
          {label}
        </span>
      </label>
    </div>
  );
};
